























































































































































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import { appModule } from "@/store/modules/app";
import Service from "@/services/DaftarRegisterPasien";
import DashboardDokterStore from "@/store/modules/DashboardDokterStore";
import EncounterIndex from "@/services/EncounterIndex";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import DialogResumeRanap from "@/components/resume/DialogResumeRanap.vue";
import DialogSuratKeteranganMedis from "@/components/kunjunganPasien/DialogSuratKeteranganMedis.vue";
import { localISODate } from "@/utils/localDate";
import { pemeriksaanRouteName } from "@/utils/unit";
import { RALAN_FORM_INDEX } from "@/utils/ralanFormRegistry";
import {
  DaftarRegisterMode,
  DokumenBelumTtd,
  RegisterPasienJenis,
  RegisterPasienJenisRuang,
  RegisterPasienParams,
  RegisterPasienRow,
  RegisterPasienSort,
  RegisterPasienStatus,
  RegisterPasienTableOptions,
  ResumeBelumLengkapStatus
} from "@/types/daftarRegisterPasien";

const MODE_PRESET: Record<
  DaftarRegisterMode,
  {
    label: string;
    status: RegisterPasienStatus;
    jenis: RegisterPasienJenis;
    sort: RegisterPasienSort;
    belumResume?: boolean;
    dpBelumTtd?: boolean;
    scopeUser?: boolean;
    jenisRuang?: RegisterPasienJenisRuang;
  }
> = {
  ralan: {
    label: "Pasien Rawat Jalan",
    status: "dirawat",
    jenis: "ralan",
    sort: "tgl_asc"
  },
  ranap: {
    label: "Pasien Rawat Inap",
    status: "dirawat",
    jenis: "ranap",
    sort: "tgl_asc"
  },
  "belum-resume": {
    label: "Resume Belum Dilengkapi",
    status: "pulang",
    jenis: "semua",
    sort: "ranap_first",
    belumResume: true
  },
  "dp-belum-ttd": {
    label: "Dokumen Perlu Verifikasi",
    status: "semua",
    jenis: "semua",
    sort: "tgl_desc",
    dpBelumTtd: true,
    scopeUser: true
  },
  administrasi: {
    label: "",
    status: "dirawat",
    jenis: "semua",
    sort: "tgl_desc",
    jenisRuang: "ranap"
  }
};

@Component({
  components: {
    VCDateTimePicker,
    UnitRuangPicker,
    DialogResumeRanap,
    DialogSuratKeteranganMedis
  }
})
export default class DaftarRegisterPasien extends Vue {
  items: RegisterPasienRow[] = [];
  totalItems = 0;
  lastPage = 1;

  itemsPerPageOptions = [10, 25, 50, 100];
  loading = false;
  busyReg: number | string | null = null;

  searchPx = "";
  filterStatus: RegisterPasienStatus = "dirawat";
  filterResume: ResumeBelumLengkapStatus = "semua";
  filterJenis: RegisterPasienJenis = "semua";
  filterJenisRuang: RegisterPasienJenisRuang = "ranap";
  filterUnit: string | null = null;
  filterDokter: string | null = null;
  tglStart: string | null = null;
  tglEnd: string | null = null;
  tglPulangStart: string | null = null;
  tglPulangEnd: string | null = null;

  mode: DaftarRegisterMode | null = null;

  dialogRanap = false;
  dialogRegister = "";
  dialogRm = "";

  dialogSkm = false;
  skmRegister = "";

  options: RegisterPasienTableOptions = {
    page: 1,
    itemsPerPage: 25
  };

  hasFetched = false;
  private lastParams = "";

  statusOptions = [
    { text: "Masih Dirawat", value: "dirawat" },
    { text: "Sudah Pulang", value: "pulang" },
    { text: "Semua", value: "semua" }
  ];

  resumeStatusOptions: { text: string; value: ResumeBelumLengkapStatus }[] = [
    { text: "Semua", value: "semua" },
    { text: "Belum Dibuat", value: "belum_dibuat" },
    { text: "Belum TTD", value: "belum_ttd" }
  ];

  jenisOptions = [
    { text: "Semua", value: "semua" },
    { text: "Rawat Inap", value: "ranap" },
    { text: "Rawat Jalan / IGD", value: "ralan" }
  ];

  jenisRuangOptions: { text: string; value: RegisterPasienJenisRuang }[] = [
    { text: "Rawat Inap", value: "ranap" },
    { text: "Rawat Jalan", value: "ralan" },
    { text: "IGD", value: "igd" }
  ];

  get stateuser() {
    return userModule.user;
  }

  get isDpjp(): boolean {
    return !!this.stateuser.map_cdoc;
  }

  get listDokter() {
    return storeDokter.listAll;
  }

  get modeLabel(): string {
    return this.mode ? MODE_PRESET[this.mode].label : "";
  }

  get isBelumResume(): boolean {
    return this.mode === "belum-resume";
  }

  get showTtdDp(): boolean {
    return this.mode === "dp-belum-ttd";
  }

  get isAdministrasi(): boolean {
    return this.mode === "administrasi";
  }

  get showBuatResume(): boolean {
    return this.isDpjp || this.isBelumResume;
  }

  get unitKategori(): string[] {
    if (this.isAdministrasi) {
      return this.filterJenisRuang === "ralan"
        ? ["ralan", "penunjang"]
        : [this.filterJenisRuang];
    }

    if (this.filterJenis === "ranap") {
      return ["ranap"];
    }

    if (this.filterJenis === "ralan") {
      return ["ralan"];
    }

    return [];
  }

  get unitDikecualikan(): string[] {
    return this.isAdministrasi && this.filterJenisRuang === "ralan" ? ["01"] : [];
  }

  get headers() {
    if (this.isAdministrasi) {
      return [
        { text: "Pasien (No RM · JK · Umur)", value: "pasien.nama" },
        { text: "Alamat", value: "pasien.alamat" },
        { text: "Register / SEP", value: "register_id" },
        { text: "Tanggal Masuk", value: "tgl_in" },
        { text: "Tanggal Pulang", value: "tgl_out" },
        { text: "DPJP", value: "dokter.nama" },
        { text: "Jaminan", value: "cara_bayar.nama" },
        { text: "Ruang / Unit / Kelas / No TT", value: "unit.nama" },
        { text: "Total Biaya", value: "total_biaya", align: "right" },
        { text: "Aksi", value: "action", align: "center", width: "120px" }
      ];
    }

    return [
      { text: "Pasien (RM · JK · Umur)", value: "pasien.nama" },
      { text: "Alamat", value: "pasien.alamat" },
      { text: "Register / SEP", value: "register_id" },
      { text: "Masuk / Pulang", value: "tgl_in" },
      { text: "DPJP", value: "dokter.nama" },
      { text: "Jaminan", value: "cara_bayar.nama" },
      { text: "Unit / Kelas / TT", value: "unit.nama" },
      { text: "Total Biaya", value: "total_biaya", align: "right" },
      { text: "Aksi", value: "action", align: "center", width: "150px" }
    ];
  }

  kelasTt(item: RegisterPasienRow): string {
    return [
      item.kelas ? `Kls ${item.kelas}` : "",
      item.nomor ? `TT ${item.nomor}` : ""
    ]
      .filter(Boolean)
      .join(" · ");
  }

  get tglStartDate(): Date | null {
    return this.strToDate(this.tglStart);
  }

  get tglEndDate(): Date | null {
    return this.strToDate(this.tglEnd);
  }

  setTglStart(val: Date | null) {
    this.tglStart = val ? localISODate(val) : null;
  }

  setTglEnd(val: Date | null) {
    this.tglEnd = val ? localISODate(val) : null;
  }

  get tglPulangStartDate(): Date | null {
    return this.strToDate(this.tglPulangStart);
  }

  get tglPulangEndDate(): Date | null {
    return this.strToDate(this.tglPulangEnd);
  }

  setTglPulangStart(val: Date | null) {
    this.tglPulangStart = val ? localISODate(val) : null;
  }

  setTglPulangEnd(val: Date | null) {
    this.tglPulangEnd = val ? localISODate(val) : null;
  }

  private strToDate(val: string | null): Date | null {
    if (!val) {
      return null;
    }

    const p = val.split("-").map(Number);

    return new Date(p[0], p[1] - 1, p[2]);
  }

  @Watch("options", { deep: true })
  onOptionsChange() {
    if (this.hasFetched) {
      this.getList();
    }
  }

  @Watch("filterJenis")
  onJenisChange() {
    this.filterUnit = null;
  }

  @Watch("filterJenisRuang")
  onJenisRuangChange() {
    this.filterUnit = null;
  }

  get routeModeKey(): string {
    const meta = this.$route.meta ? this.$route.meta.daftarRegisterMode : null;
    const q = this.$route.query ? this.$route.query.mode : null;

    return String(meta || q || "");
  }

  @Watch("routeModeKey")
  onModeChange() {
    this.applyMode();
    this.tampilkan();
  }

  applyMode() {
    const key = this.routeModeKey;

    this.mode = Object.prototype.hasOwnProperty.call(MODE_PRESET, key)
      ? (key as DaftarRegisterMode)
      : null;

    const preset = this.mode ? MODE_PRESET[this.mode] : null;

    this.filterStatus = preset ? preset.status : "dirawat";
    this.filterJenis = preset ? preset.jenis : "semua";
    this.filterJenisRuang = (preset && preset.jenisRuang) || "ranap";
    this.filterUnit = null;
    this.filterResume = "semua";
    this.tglStart = null;
    this.tglEnd = null;
    this.tglPulangStart = null;
    this.tglPulangEnd = null;

    this.filterDokter =
      this.isDpjp && !this.isAdministrasi && !(preset && preset.scopeUser)
        ? String(this.stateuser.map_cdoc)
        : null;
  }

  resetFilter() {
    this.searchPx = "";
    this.applyMode();
  }

  tampilkan() {
    this.hasFetched = true;
    if (this.options.page !== 1) {
      this.options = { ...this.options, page: 1 };
    }

    this.getList(true);
  }

  // ------------------------------------------------------------------ fetch
  get sort(): RegisterPasienSort {
    if (this.mode) {
      return MODE_PRESET[this.mode].sort;
    }

    return this.isDpjp ? "ranap_first" : "";
  }

  buildParams(): RegisterPasienParams {
    const params: RegisterPasienParams = {
      page: this.options.page,
      per_page: this.options.itemsPerPage,
      status: this.filterStatus
    };

    if (this.isAdministrasi) {
      params.jenis_ruang = this.filterJenisRuang;
    } else if (this.filterJenis !== "semua") {
      params.kategori = this.filterJenis;
    }

    if (this.filterUnit) params.unit = this.filterUnit;
    if (this.filterDokter) params.dokter = this.filterDokter;
    if (this.searchPx) params.q = this.searchPx;
    if (this.tglStart) params.tgl_start = this.tglStart;
    if (this.tglEnd) params.tgl_end = this.tglEnd;
    if (this.tglPulangStart) params.tgl_pulang_start = this.tglPulangStart;
    if (this.tglPulangEnd) params.tgl_pulang_end = this.tglPulangEnd;
    if (this.sort) params.sort = this.sort;

    if (this.mode && MODE_PRESET[this.mode].belumResume) {
      params.belum_resume = 1;

      if (this.filterResume !== "semua") {
        params.resume_status = this.filterResume;
      }
    }

    if (this.mode && MODE_PRESET[this.mode].dpBelumTtd) {
      params.dp_belum_ttd = 1;
    }

    return params;
  }

  getList(paksa = false) {
    const params = this.buildParams();
    const tandaTangan = JSON.stringify(params);

    if (!paksa && tandaTangan === this.lastParams) {
      return;
    }

    this.lastParams = tandaTangan;
    this.loading = true;

    Service.getList(params)
      .then(resp => {
        this.items = resp && resp.data ? resp.data : [];
        this.totalItems = resp && resp.meta ? resp.meta.total : 0;
        this.lastPage =
          resp && resp.meta && resp.meta.last_page ? resp.meta.last_page : 1;
      })
      .catch(() => {
        this.items = [];
        this.totalItems = 0;
        this.lastPage = 1;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  changePerPage(val: number) {
    this.options = { ...this.options, itemsPerPage: val, page: 1 };
  }

  reload() {
    if (this.hasFetched) {
      this.getList(true);
    } else {
      this.tampilkan();
    }
  }

  // ------------------------------------------------------------- navigasi
  private isRanap(item: RegisterPasienRow): boolean {
    return item.kategori === "ranap";
  }

  buatResume(item: RegisterPasienRow) {
    if (this.isRanap(item)) {
      this.dialogRegister = String(item.register_id);
      this.dialogRm = item.pasien.rm;
      this.dialogRanap = true;

      return;
    }

    this.gotoRalan(item, "tab-suket", {
      topTab: "tab-suket",
      tab: "tab-resume",
      category: "Resume & Rawat",
      bukaForm: "1"
    });
  }

  segarkanDaftar() {
    if (this.hasFetched) {
      this.getList(true);
    }

    DashboardDokterStore.fetch(true);
  }

  ttdDischargePlanning(item: RegisterPasienRow) {
    this.gotoRanap(item, {
      topTab: "tab-rekam-medis",
      tab: "tab-discharge-planning",
      category: "Resume dan MPP"
    });
  }

  ttdDokumen(item: RegisterPasienRow, dok: DokumenBelumTtd) {
    if (dok.kode === "discharge-planning") {
      this.ttdDischargePlanning(item);

      return;
    }

    if (dok.kode === "surat-keterangan-medis") {
      this.bukaSkm(item);

      return;
    }

    const query: Record<string, string> = {
      topTab: "tab-suket",
      tab: String(dok.tab)
    };

    const unit = dok.unit_id || item.unit.id;

    if (pemeriksaanRouteName(unit) === "pemeriksaan-ranap") {
      this.gotoRanap(item, query);

      return;
    }

    const entri = RALAN_FORM_INDEX.find(
      e => e.topTab === "tab-suket" && e.elemId === dok.tab
    );

    if (entri && entri.category) {
      query.category = entri.category;
    }

    this.gotoRalan(item, "tab-suket", query);
  }

  async bukaSkm(item: RegisterPasienRow) {
    this.busyReg = item.register_id;

    await storePasien.getDataPasien(item.pasien.rm).catch(() => undefined);

    this.busyReg = null;

    const px = storePasien.identitasPasien;

    if (!px || Number(px.rm) !== Number(item.pasien.rm)) {
      appModule.sendErrorNotice(
        "Identitas pasien gagal dimuat. Buka SKM melalui Detail Pasien (Riwayat Kunjungan)."
      );

      return;
    }

    this.skmRegister = String(item.register_id);
    this.dialogSkm = true;
  }

  @Watch("dialogSkm")
  onDialogSkm(buka: boolean) {
    if (!buka) {
      storePasien.clear();
    }
  }

  halamanPemeriksaan(item: RegisterPasienRow) {
    if (this.isAdministrasi) {
      if (this.isRanap(item)) {
        this.gotoRanap(item, {});
      } else {
        this.gotoRalan(item);
      }

      return;
    }

    if (this.isRanap(item)) {
      this.gotoRanap(item, { topTab: "tab-rekam-medis" });
    } else {
      this.gotoRalan(item, "tab-soap");
    }
  }

  bukaBilling(item: RegisterPasienRow) {
    if (this.isRanap(item)) {
      this.gotoRanap(item, { topTab: "tab-billing" });
    } else {
      this.gotoRalan(item, "tab-pelayanan", { topTab: "tab-pelayanan" });
    }
  }

  riwayatPemeriksaan(item: RegisterPasienRow) {
    this.$router.push({
      name: "detail-pasien",
      params: { rm: item.pasien.rm }
    });
  }

  private async gotoRanap(
    item: RegisterPasienRow,
    query: Record<string, string>
  ) {
    this.busyReg = item.register_id;

    await EncounterIndex.regRanap(item.register_id, item.pasien.rm).catch(
      () => undefined
    );

    this.busyReg = null;

    this.$router.push({
      name: "pemeriksaan-ranap",
      params: { register: String(item.register_id), rm: item.pasien.rm },
      query
    });
  }

  private gotoRalan(
    item: RegisterPasienRow,
    page?: string,
    query?: Record<string, string>
  ) {
    const params: Record<string, string> = {
      register: String(item.register_id),
      rm: item.pasien.rm
    };

    if (page) {
      params.page = page;
    }

    this.$router.push({ name: "pemeriksaan", params, query });
  }

  formatRupiah(val: number | null): string {
    if (val === null || val === undefined) {
      return "-";
    }

    return "Rp " + Number(val).toLocaleString("id-ID");
  }

  created() {
    this.applyMode();

    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  mounted() {
    if (this.isDpjp || this.mode) {
      this.$nextTick(() => this.tampilkan());
    }
  }
}
